export const PROMOS_REDUCER_NAME = 'promos'
export const PROMO_PRODUCTS_REDUCER_NAME = 'products'
export const PROMO_CAMPAIGNS_REDUCER_NAME = 'campaigns'
export const PROMO_GROUP_REDUCER_NAME = 'promoGroup'
export const PROMO_GROUP_PRODUCTS_REDUCER_NAME = 'promoGroupProducts'
export const ALL_PROMO_GROUPS_REDUCER_NAME = 'allPromoGroups'
